import { loadImage } from "./imageEdit/loadImage";

export const isImageDark = async (imageSrc: string) => {
    const fuzzy = 0.1;
    const { image } = await loadImage(imageSrc, true);

    var canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;

    const ctx = canvas.getContext("2d");
    if (!ctx) throw new Error("Canvas 2d context not found");
    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const data = imageData.data;
    let r: number, g: number, b: number, max_rgb: number;
    let light = 0,
        dark = 0;

    for (let x = 0, len = data.length; x < len; x += 4) {
        r = data[x];
        g = data[x + 1];
        b = data[x + 2];

        max_rgb = Math.max(Math.max(r, g), b);
        if (max_rgb < 128) dark++;
        else light++;
    }

    const dl_diff = (light - dark) / (image.width * image.height);
    return dl_diff + fuzzy < 0;
};
